import * as React from "react";
import { cn } from "~/lib/utils";
import { Label } from "./label";

export interface FormFieldProps {
  id: string;
  label: string;
  helper?: string;
  error?: string;
  required?: boolean;
  className?: string;
  children: React.ReactElement<{
    id?: string;
    "aria-describedby"?: string;
    "aria-invalid"?: boolean | "true" | "false";
  }>;
}

export function FormField({ id, label, helper, error, required, className, children }: FormFieldProps) {
  const descId = `${id}-desc`;
  const child = React.Children.only(children);
  const describedBy = helper || error ? descId : undefined;
  const cloned = React.cloneElement(child, {
    id,
    ...(describedBy !== undefined && { "aria-describedby": describedBy }),
    ...(error !== undefined && { "aria-invalid": true as const }),
  });
  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <Label htmlFor={id} {...(required !== undefined && { required })}>{label}</Label>
      {cloned}
      {error ? (
        <p id={descId} role="alert" className="text-xs text-error-ink">{error}</p>
      ) : helper ? (
        <p id={descId} className="text-xs text-foreground-muted">{helper}</p>
      ) : null}
    </div>
  );
}
